export const initFloatingButton = () => {
  const floatingButton = document.querySelector('.floating-button');
  const frontpageSteps = document.querySelector('.frontpage-steps');

  if (floatingButton && frontpageSteps) {
    const checkPosition = () => {
      const rect = frontpageSteps.getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      const sectionMiddle = rect.top + rect.height / 3;
      const isMiddleInViewport = sectionMiddle >= viewportHeight / 2 && sectionMiddle <= viewportHeight;

      if (isMiddleInViewport) {
        floatingButton.classList.add('d-none');
      } else {
        floatingButton.classList.remove('d-none');
      }
    };

    window.addEventListener('scroll', checkPosition);
    window.addEventListener('resize', checkPosition);

    checkPosition();
  }
}
